import type { LevelTableColumn } from 'redesign';
import { IconIsolationMode } from 'assets/img';
import { Cell, Header } from 'shared/components/planner/common/utils';
import { useCallback } from 'react';
import { DateTime } from 'luxon';
import { useSiteDetection } from 'shared/hooks';
import { useLocation } from 'react-router';
import { IconButton } from '@mui/material';
import {
  FailedBulkShiftActionsCellProp,
  FailedBulkShiftActionsColumnDefinition,
} from './failed-bulk-shift-actions-table.types';

export const getFailedBulkShiftActionsColumnDefinition: () => LevelTableColumn<FailedBulkShiftActionsColumnDefinition>[] =
  () => {
    const error: LevelTableColumn<FailedBulkShiftActionsColumnDefinition> = {
      Header: () => <Header>Foutmelding</Header>,
      accessor: 'error',
      Cell: Cell,
    };
    const shiftName: LevelTableColumn<FailedBulkShiftActionsColumnDefinition> = {
      Header: () => <Header>Functie</Header>,
      accessor: 'shiftName',
      Cell: Cell,
      width: '100px',
    };
    const utcStartEndDateTime: LevelTableColumn<FailedBulkShiftActionsColumnDefinition> = {
      Header: () => <Header>Datum & tijd</Header>,
      accessor: 'dateStartEndTime',
      Cell: Cell,
      width: '100px',
    };
    const action: LevelTableColumn<FailedBulkShiftActionsColumnDefinition> = {
      Header: () => <Header>Actie</Header>,
      accessor: 'action',
      Cell: ActionCell,
      width: '50px',
    };

    return [error, shiftName, utcStartEndDateTime, action];
  };

const ActionCell = (cell: FailedBulkShiftActionsCellProp<'action'>) => {
  const currentDate = DateTime.now().toISODate();
  const { site } = useSiteDetection();
  const { pathname } = useLocation();
  const url =
    site === 'ogp'
      ? pathname.concat(`?fromDate=${currentDate}&shiftId=${cell.value}`)
      : `/hq/planner/shifts?fromDate=${currentDate}&shiftDetailId=${cell.value}`;
  const navigateCallback = useCallback(() => {
    window.open(url, '_blank');
  }, []);

  return (
    <IconButton onClick={navigateCallback}>
      <IconIsolationMode />
    </IconButton>
  );
};
